import { useTenant } from '../contexts/TenantContext';

/**
 * useFeature('cashback') → boolean
 * Reads from tenant.features (set by super_admin per tenant).
 */
export const useFeature = (name) => {
  const { features } = useTenant();
  return Boolean(features?.[name]);
};
